import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import Home from './components/Home';
import Menu from './components/Menu';
// import Promotions from './components/Promotions';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import './index.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Router>
        <App />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          {/* <Route path="/promotions" element={<Promotions />} /> */}
          <Route path="/testimonials" element={<Testimonials />} />
        </Routes>
        <Footer />
      </Router>
    </React.StrictMode>
  );
}
